import React from 'react';
import { PlayCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden px-6 py-14 bg-[#0a0a0a]" data-id="element-124">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-rose/10 rounded-full blur-[120px] pointer-events-none" data-id="element-125" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-126">
        <FadeIn delay={0.1} data-id="element-127">
          <h1 className="font-serif text-4xl md:text-6xl font-bold leading-tight mb-6" data-id="element-128">
            Si te dejó en visto… no es porque no le importes.{' '}
            <br className="hidden md:block" data-id="element-129" />
            <span className="text-brand-rose italic" data-id="element-130">
              Es porque escribiste esto.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-131">
          <p className="text-lg md:text-xl text-brand-lightGray mb-10 max-w-2xl mx-auto font-light" data-id="element-132">
            Este sistema psicológico te enseña exactamente qué decir para que te
            vuelva a responder, incluso si ya te ignoró.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-133">
          {/* Instagram Reel Embed */}
          <div className="relative w-72 md:w-80 mx-auto mb-10 rounded-3xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(225,29,72,0.15)]" data-id="element-134">
            <iframe src="https://www.instagram.com/reel/DW2Jj8Dk4PC/embed/" className="w-full aspect-[9/16] border-0" allowFullScreen scrolling="no" title="El error que hace que te dejen en visto" data-id="element-135" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-136">
          <a href="https://oliverpublicista-2.myshopify.com/cart/43150580056154:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-2 px-8 py-5 bg-brand-rose text-white text-lg font-bold rounded-full overflow-hidden transition-transform hover:scale-105 active:scale-95 shadow-[0_0_30px_rgba(225,29,72,0.3)]" data-id="element-137">
            <span className="relative z-10 flex items-center gap-2" data-id="element-138">
              👉 QUIERO QUE ME VUELVA A RESPONDER
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-139" />
          </a>
          <p className="mt-4 text-sm text-brand-lightGray font-medium" data-id="element-140">
            Acceso inmediato • 100% práctico
          </p>
        </FadeIn>
      </div>
    </section>;
}